module.exports = __webpack_public_path__ + "img/gmail_ios_authzen.1c53617b.gif";